/**
 * Created by rak on 4/28/2015.
 */

'use strict';

angular.module('dashboard.vehicleList', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('vehicleListWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.vehicleList.vehicleListTitle';
          },
          description: function () {
            return 'dashBoard.fleetManagement.vehicleList.description';
          }
        },
        controller: 'vehicleListCtrl',
        templateUrl: 'components/dashboard/vehicle/vehicleListWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          vehicleGroup: null,
          noOfGridRows: ''
        },
        edit: {
          templateUrl: 'components/dashboard/vehicle/vehicleListEdit.tpl.html',
          reload: false,
          controller: 'vehicleListEditCtrl'
        }
      });
  }).service('vehicleListWidgetService', function (dsaComponentsConfig, crudService, $translate, commonTrackService, widgetSettingsCreatorService) {

    this.getVehicleList = function (vechileGroup, isDataRefresh) {
      var requestParam = {
        statusCode: 'all',
        vehicleGroup: vechileGroup,
        dataRefresh: isDataRefresh,
        timeTo: '-0d',
        timeFrom: ''
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('overview', 'vehiclelist', param);
    };

    this.getStatusCodeComboList = function () {
      return crudService.get('overview/statuscode');
    };

    this.getVehicleEventDetailList = function (deviceId, isDataRefresh, startDate, endDate) {
      var requestParam = {
        statusCode: '',
        vehicleGroup: '',
        dataRefresh: isDataRefresh,
        timeTo: endDate,
        timeFrom: startDate,
        reportName: 'EventDetail'
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('overview', 'vehicleeventdetail/' + deviceId, param);
    };

    this.getVehicleOrdersList = function (deviceId, isDataRefresh, startDate, endDate) {
      var requestParam = {
        statusCode: '',
        vehicleGroup: '',
        dataRefresh: isDataRefresh,
        timeTo: endDate,
        timeFrom: startDate,
        reportName: 'DeviceWorkOrders'
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('overview', 'deviceworkorders/' + deviceId, param);
    };

    this.getCargoQualityList = function (deviceId, isDataRefresh, startDate, endDate) {
      var requestParam = {
        statusCode: '',
        vehicleGroup: '',
        dataRefresh: isDataRefresh,
        timeTo: endDate,
        timeFrom: startDate,
        reportName: 'EventDetailCargoQuality'
      };
      var param = {
        'filter': JSON.stringify(requestParam)
      };
      return crudService.customGET('overview', 'cargoquality/' + deviceId, param);
    };

    this.getMoreFunctionSettings = function () {
      var _moreFunctionSetting = {
        placeHolder: $translate.instant('moreFunction.button.function'),
        displayMember: 'name',
        valueMember: 'value',
        source: [{
          name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
          execute: 'createMessageEvent',
          value: 'sendMsg'
        }, {
          name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
          execute: 'createCommandEvent',
          value: 'sendCommand'
        }, {
          name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showReports'),
          value: 'showReport',
          execute: 'contextFuntion-EventDetailAll'
        }, {
          name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
          value: 'showDriverDashboard',
          execute: 'showDriverDashboard'
        }, /*{
        name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
        value: 'showPortalCommand',
        execute: 'showPortalCommand'
      },*/ {
          name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
          value: 'showFmsDashboard',
          execute: 'showFmsDashboard'
        },
        {
          name: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.copyLocationToClipboard'),
          value: 'copyLocation',
          execute: 'copyLocation'
        }
        ],

        theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, //'material', // theme: 'bootstrap',
        width:'100%',
        height:dsaComponentsConfig.jqxDefaultSetting.comboxHeight,
        autoDropDownHeight: true
      };
      return _moreFunctionSetting;
    };

    this.getContextMenuSettings = function (height) {
      var settings = { width: 200, height: height ? height : 30, autoOpenPopup: false, mode: 'popup' };
      return settings;
    };
    this.getRowSize = function () {
      var rowSize = {
        XS: {
          4: 280,
          5: 350,
          8: 300,// yet to define
          10: 580,
          20: 1025,
          15: 800,
          25: 1250,
          50: 2375,
          75: 3500,
          100: 4625
        },
        SM: {
          4: 200, // yet to define
          5: 325,
          8: 300,// yet to define
          10: 525,
          15: 730,
          20: 930,
          25: 1125,
          50: 2125,
          75: 3125,
          100: 4125
        },
        MD: {
          4: 200,
          5: 310,
          8: 395,
          10: 480,
          15: 655,
          20: 830,
          25: 1005,
          50: 1880,
          75: 2755,
          100: 3630
        },
        LG: {
          4: 200, //yet to define
          5: 285,
          8: 300,
          10: 430,
          15: 585,
          20: 735,
          25: 885,
          50: 1630,
          75: 2390,
          100: 3135
        }
      };
      return rowSize[commonTrackService.getViewPortName()];
    };

  }).controller('vehicleListCtrl', function ($scope, config, widgetSettingsCreatorService, vehicleListWidgetService, $rootScope, $timeout, $q, $translate, commonTrackService, $state, $filter, localStorageService, AuthenticationService, errorHandlingService, toastService, $interval, stateManagerService) {

    //  $scope.statusCode = config.statusCode;
    $scope.selectedFunction = '';
    $scope.overviewGridPrefix = commonTrackService.getOverviewGridPrefix();

    var TAB_VEHICLE_LIST = 0, TAB_ORDERS = 1, TAB_VEHICLE_DETAILS = 2, TAB_CARGO_QUALITY = 3;
    $scope.activeTab = TAB_VEHICLE_LIST;
    $scope.previousTab = TAB_VEHICLE_LIST;
    $scope.vehicleDetailTab = {
      disable: true
    };
    $scope.vehicleOrdersTab = {
      disable: true
    };
    $scope.cargoQualityTab = {
      disable: true
    };

    var dateRangePickerSettings = {};
    var errorObj = { type: 'F', message: '' };
    var _lastRefreshTimeS = null;
    var counterSeconds = 60;
    var counterTimeout;
    var rowSize = vehicleListWidgetService.getRowSize();
    $scope.isDataAvailable = true;
    $scope.isOrderAvailable = true;
    $scope.isDetialAvailable = true;
    $scope.uuidForElement =  $scope.$id;
    $scope.vehicleGroupSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'groupID'
      //theme: 'material' use default theme instead
    });

    $scope.customGridProperties = {
      vehicleOrders: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
        pageable: false,
        columns: []
      },
      vehicleLastLocation: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
        pageable: false,
        columns: []
      },
      vehicleEventDetails: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
        pageable: false,
        columns: []
      },
      cargoQualityDetail: {
        height: config.noOfGridRows ? rowSize[config.noOfGridRows] : 455,
        pageable: false,
        columns: []
      }
    };

    $scope.vehicleDetail = {
      date: {
        startDate: new Date().setHours(0, 0, 0, 0),
        endDate: new Date()
      }
    };

    $scope.cargoQualityDetail = {
      date: {
        startDate: new Date().setHours(0, 0, 0, 0),
        endDate: new Date()
      }
    };

    $scope.vehicleOrders = {
      date: {
        startDate: new Date().setHours(0, 0, 0, 0),
        endDate: new Date()
      }
    };

    // stateManagerService
    // Defines important params used in the widget,
    // params that can be provided to other widgets
    $scope.dataSet = {
      deviceID: null,
      startDate: null,
      endDate: null,
      lastUpdateRequest: 0
    };

    var vehicleListSource =
    {
      datatype: 'array',
      datafields: [],
      sort: null,
      localdata: []
    };

    /**
     *  temporay private variable  to store some global values , created to avoid using config object .
     *  dont use config which will be stored to localstorage and may cuase issues when reused from localstorage
     */
    var _tmpConfig ={};


    // stateManagerService
    // Used when unkown dependant (child) widget requests data.
    // Since this is a global request for data, widget needs to check if the,
    // requested fields is anything it can provide before updating.
    // Will call the dataStateUpdate event if it updates data.
    var updateRequest = $scope.$on('reqDataUpdate', function () {
      var selectedRowData = {};
      var slectedLatLocationrowData = {};
      var selectIndex = -1;
      selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getselectedrowindex');
      if (selectIndex > -1) {
        slectedLatLocationrowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getrowdata', selectIndex);
      }
      switch ($scope.activeTab) {
        case 1:
          selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleOrdersList').jqxGrid('getselectedrowindex');
          if (selectIndex > -1) {
            selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleOrdersList').jqxGrid('getrowdata', selectIndex);
          }
          break;
        case 2: //uses same row select Logic
          selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleEventDetailsList').jqxGrid('getselectedrowindex');
          if (selectIndex > -1) {
            selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleEventDetailsList').jqxGrid('getrowdata', selectIndex);
          }
          break;
        case 3:
          selectIndex = window.$('#' + $scope.overviewGridPrefix + 'cargoQualityDetailList').jqxGrid('getselectedrowindex');
          if (selectIndex > -1) {
            selectedRowData = window.$('#' + $scope.overviewGridPrefix + 'cargoQualityDetailList').jqxGrid('getrowdata', selectIndex);
          }
          break;
      }
      // push the changes to stateManagerService
      stateManagerService.updateDeviceID('vehicleListWidget', selectedRowData.deviceid, true);
      stateManagerService.updateStartDate('vehicleListWidget', $scope.dataSet.startDate, true);
      stateManagerService.updateValue('vehicleListWidget', 'endDate', $scope.dataSet.endDate, true);
      if ($scope.activeTab > TAB_VEHICLE_LIST) {
        stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', selectedRowData, true);
        stateManagerService.updateValue('vehicleListWidget', 'tab_' + TAB_VEHICLE_LIST + '_selectedRow', slectedLatLocationrowData, true);

      } else if (!_.isEmpty(slectedLatLocationrowData)) { // first tab must always return a valid selected values
        stateManagerService.updateValue('vehicleListWidget', 'tab_' + TAB_VEHICLE_LIST + '_selectedRow', slectedLatLocationrowData, true);
      }


      $rootScope.$broadcast('resDataUpdate',
        {
          widget: 'vehicleListWidget',
          activeTab: $scope.activeTab,
          dashboardName: 'dashboard.vehicleList',
          timespan: new Date().getTime()
        });
    });

    var dateRangeCustomEventHandler = {
      eventHandlers: {
        'apply.daterangepicker': function () {
          if ($scope.activeTab === TAB_VEHICLE_DETAILS  ) {
            $scope.vehicleDetail.date.startDate = moment($scope.vehicleDetail.date.startDate);
            $scope.vehicleDetail.date.endDate = moment($scope.vehicleDetail.date.endDate);

            _tmpConfig.startDate = $scope.vehicleDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
            _tmpConfig.endDate = $scope.vehicleDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
            loadVehicleEventDetailList(_tmpConfig.deviceId, false, _tmpConfig.startDate, _tmpConfig.endDate);
          }
          if ($scope.activeTab === TAB_ORDERS) {
            $scope.vehicleOrders.date.startDate = moment($scope.vehicleOrders.date.startDate);
            $scope.vehicleOrders.date.endDate = moment($scope.vehicleOrders.date.endDate);
            _tmpConfig.startDate = $scope.vehicleOrders.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
            _tmpConfig.endDate = $scope.vehicleOrders.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
            loadVehicleOrdersList(_tmpConfig.deviceId, false, _tmpConfig.startDate, _tmpConfig.endDate).then(function (orderList) {
              if (orderList && orderList.length > 0) {
                //select the first as default
                var rowindex = _getCurrentRowIndex('vehicleOrdersList', orderList.length);
                if (rowindex) {
                  var rowData = orderList[rowindex];
                  if (rowData) {
                    var _tmpStartDate = commonTrackService.formatReportDateTime(rowData.workorderstartdate, rowData.workorderstarttime, false);
                    var _tmpEndDate = commonTrackService.formatReportDateTime(rowData.workorderenddate, rowData.workorderendtime, false);
                    if (_tmpStartDate && _tmpStartDate) {
                      broadcastEventData.selectedOrderRow = rowData;
                      if ($scope.activeTab === TAB_ORDERS) {
                        $rootScope.$broadcast('tabEvent', {
                          'tabName': 'vehicleOrders',
                          'repoVehicle': rowData.deviceid,
                          'startDate': _tmpStartDate,
                          'endDate': _tmpEndDate,
                          dashboardName: 'dashboard.vehicleList',
                          isDataFromTab: true,
                          tabNumber: 1

                        });

                        // stateManagerService
                        // Push values to the stateManagerService
                        stateManagerService.updateDeviceID('vehicleListWidget', rowData.deviceid, true);
                        stateManagerService.updateStartDate('vehicleListWidget', _tmpStartDate, true);
                        stateManagerService.updateValue('vehicleListWidget', 'endDate', _tmpStartDate, true);
                        stateManagerService.updateValue('vehicleListWidget', 'orderData', rowData, false);
                        stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', rowData, true);

                        $rootScope.$broadcast('dataStateUpdate',
                          {
                            widget: 'vehicleListWidget',
                            activeTab: $scope.activeTab,
                            dashboardName: 'dashboard.vehicleList',
                            timespan: new Date().getTime()
                          });

                      }
                    }
                  }
                }

              }
            });
          }

          //  The tab is hidden and its not , enable when the related tab is activated again
          /* if ($scope.activeTab === 3) {
            $scope.cargoQualityDetail.date.startDate = moment($scope.cargoQualityDetail.date.startDate);
            $scope.cargoQualityDetail.date.endDate = moment($scope.cargoQualityDetail.date.endDate);
            _tmpConfig.startDate = $scope.cargoQualityDetail.date.startDate.format('YYYY/MM/DD/HH:mm:ss');
            _tmpConfig.endDate = $scope.cargoQualityDetail.date.endDate.format('YYYY/MM/DD/HH:mm:ss');
            loadCragoQualityList(_tmpConfig.deviceId, false, _tmpConfig.startDate, _tmpConfig.endDate);
          } */
        },

      }
    };
    var lastLocationContextMenu = {};
    var ordersContextMenu = {};

    var isLastLocationCtxInitialized = false;
    var isOrdersCtxInitialized = false;

    //var orderCntxMenu = {};
    commonTrackService.getDatePickerDetails().then(function (settings) {
      var tab = $scope.activeTab === TAB_CARGO_QUALITY ? 'EventDetailCargoQuality' : $scope.activeTab === TAB_VEHICLE_DETAILS ? 'EventDetail' : undefined;
      $scope.options = commonTrackService.getDateRangePickerSettings(dateRangeCustomEventHandler, commonTrackService.getDateRangePickerRange(settings,tab));
      dateRangePickerSettings = settings;
    });
    $scope.moreFuctionSetting = vehicleListWidgetService.getMoreFunctionSettings();


    var broadcastEventData = {
      selectedRow: {},
      selectedVehicleGroup: '',
      selectedStatusCode: '',
      selectedVehicleGroupLabel: '',
      eventSource: '',
      selectedOrderRow: {},
      isRefreshStarted: false,
      lastTabName: '',
      dashboardName: 'dashboard.vehicleList',
      isDataFromTab: true
    };


    var _lastSelctedDeviceId = null;
    var gtsUserSettings = null;

    //  status code not needed for 1'st release
    /* $scope.statusCodeSettings = widgetSettingsCreatorService.createComboxSettings({
     displayMember: 'displayName',
     valueMember: 'key'
     });*/


    var loadVehicleGroup = function () {
      return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
        if (vechileGroupList.length > 0) {
          $scope.vehicleGroupSettings.source = vechileGroupList;
          var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

          if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, config.vehicleGroup)) { // validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = config.vehicleGroup;
          }

          if (!config.vehicleGroup || cachedGroup !== config.vehicleGroup) {
            if (commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)) {// validate the local storage group is still valid ( group can change based on login )
              $scope.vehicleGroup = cachedGroup;
              config.vehicleGroup = cachedGroup;
            }
          }

          if (!$scope.vehicleGroup) {
            $scope.vehicleGroup = vechileGroupList[0].groupID;
          }

        }
      });
    };

    var loadFleetServerDetails = function () {
      return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
        $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
      });
    };

    var loadVechileList = function (vehicleGroup, dataRefresh, isAutorefresh) {
      $scope.stop();
      //statusCode = statusCode !== undefined && statusCode !== null ? statusCode : 'all';
      return vehicleListWidgetService.getVehicleList(vehicleGroup, dataRefresh).then(function (vehicleResult) {
        if (vehicleResult.dataList) {
          $scope.isDataAvailable = true;
          if (dataRefresh) {
            $scope.customGridProperties.vehicleLastLocation.columns = commonTrackService.getColumnProperties(vehicleResult.gridSettings.overviewListGrids[0].columnProperties, vehicleResult.columnTranslation, { moduleName: 'vehicleLastLocation' });
            vehicleListSource.sort = commonTrackService.getCustomSortFunction($scope.overviewGridPrefix + 'vehicleLastLocationList', vehicleListSource);
            vehicleListSource.localdata = vehicleResult.dataList;
            _lastRefreshTimeS = vehicleResult.dataCreationTimeSeconds;
            var _preferedDeviceId = gtsUserSettings.preferredDeviceID;
            var _preferedVehicleRowIndex = null;
            // users preferred vehicle selection from user settings.
            if (_preferedDeviceId && dataRefresh && $state.previous.name === 'login') {
              _preferedVehicleRowIndex = getRowIndex(vehicleListSource, _preferedDeviceId);
            }
            var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.lastLocation') };
            $scope.vehicleLastLocGridSettings = commonTrackService.getGridSettings('vehicleLastLocation', $scope.customGridProperties.vehicleLastLocation, _preferedVehicleRowIndex, _additionalProperties);
            $scope.vehicleListdataAdapter = new window.$.jqx.dataAdapter(vehicleListSource);
            $scope.vehicleLastLocGridSettings.source = $scope.vehicleListdataAdapter;
          }
          else {
            vehicleListSource.localdata = vehicleResult.dataList;
            _lastRefreshTimeS = vehicleResult.dataCreationTimeSeconds;
            commonTrackService.updateBoundData($scope.overviewGridPrefix + 'vehicleLastLocationList');
          }
        }
      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isDataAvailable = false;
        }
      }).finally(function () {
        $scope.counter = counterSeconds;
        $scope.createVehicleListGrid = true;

        // When widget loaded first time , The auto refresh should start by default
        $timeout(function () {
          if (_isDefaultAutoRefreshBeginValid()) {
            $scope.startCounter();
          } else {
            $scope.stop(); // stop ROUGE running AutoRefresh if any .
          }
        }, 0);


        // send row select event after evey request to update the broadcastEventData[selected grid row details].
        if (isAutorefresh && _lastSelctedDeviceId || !dataRefresh && _lastSelctedDeviceId || _lastSelctedDeviceId === 0) {
          $timeout(function () {
            broadcastEventData.isRefreshStarted = true;
            var _rowIndex = getRowIndex(vehicleListSource, _lastSelctedDeviceId); // find row index based on device id
            var sortinformation = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getsortinformation');
            if (_rowIndex && !sortinformation.sortcolumn && !sortinformation.sortdirection) { // if sort available the custom sort will do the row selection .
              window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('selectrow', _rowIndex);
            }
            if ($scope.vehicleOrdersTab.disable) {
              broadcastEventData.selectedOrderRow = null;
            }
          }, 0);
        }
      });
    };

    /**
     * Decides when to intiate DEFAULT auto refresh.
     * ----------------------------------------------------------------------------------------------------------------------------------------------------------------------
     * Auto refresh only valid for main TAB  under following situations
     *
     *  grid data is already read from backend '$scope.isDataAvailable'  AND no existing auto refresh is statred :: When the widget first loaded / when comes to dashboard
     *
     * OR
     *
     *  grid data is already read from backend '$scope.isDataAvailable'  AND auto refresh refence object in the state of 'canceled'
     * ----------------------------------------------------------------------------------------------------------------------------------------------------------------------
     *
     */
    function _isDefaultAutoRefreshBeginValid(){
      if ($scope.activeTab === TAB_VEHICLE_LIST) { // TAB check is must to prevent unexpeted behaviour under Async situations.

        // grid data is already read from backend '$scope.isDataAvailable'  AND no existing auto refresh statred
        if (($scope.isDataAvailable && !counterTimeout)) {
          return true;

        }
        //grid data is already read from backend '$scope.isDataAvailable'  AND auto refresh refence object in the state of 'canceled'
        if ($scope.isDataAvailable && counterTimeout.$$state && counterTimeout.$$state.value === 'canceled') {
          return true;
        }

      }
      return false;

    }

    function getRowIndex(vehicleListSource, _preferedDeviceId) {
      for (var i = 0; i < vehicleListSource.localdata.length; i++) {
        if (_preferedDeviceId === vehicleListSource.localdata[i].deviceid) {
          return i;
        }
      }
      return null;
    }

    function contextFuntion(reportName) {
      var selectedData = _initRequestData(undefined, '-');

      $state.go('reports.vehicleDetail', {
        'reportName': reportName,
        'vehicleId': _tmpConfig.deviceId,
        'dateFrom': selectedData._tmpStartDate,
        'dateTo': selectedData._tmpEndDate
      });
    }

    function createMessageEvent() {
      $rootScope.$broadcast('newMsgEvent', {});
    }

    function createCommandEvent() {
      $rootScope.$broadcast('newCommandEvent', {});
    }

    function showDriverDashboard() {
      $state.go('driverdashboard');
    }

    function showPortalCommand() {
      $state.go('portalcommand');
    }

    function showFmsDashboard() {
      $state.go('fmsdashboard');
    }


    var _commonFunction = {
      'contextFuntion': contextFuntion,
      'createMessageEvent': createMessageEvent,
      'createCommandEvent': createCommandEvent,
      'showDriverDashboard': showDriverDashboard,
      'showPortalCommand': showPortalCommand,
      'showFmsDashboard': showFmsDashboard,
      'copyLocation': copyLocation
    };
    var _contextSourceObj = {
      lastLocCtxSource: [{
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showReports'),
        'execute': contextFuntion,
        'reportName': 'EventDetailAll'
      },
      {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
        execute: createMessageEvent
      },
      {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
        execute: createCommandEvent
      },
      {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
        execute: showDriverDashboard
      }, /*{
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
        execute: showPortalCommand
      }, */{
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showFmsDashboard'),
        execute: showFmsDashboard
      },
      {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.copyLocationToClipboard'),
        execute: copyLocation
      }
      ],
      ordersCtxSource: [{
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showReports'),
        'execute': contextFuntion,
        'reportName': 'EventDetailAll'
      },
      {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendMsg'),
        execute: createMessageEvent
      }, {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.sendCommand'),
        execute: createCommandEvent
      }, {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showDriverDashboard'),
        execute: showDriverDashboard
      }/*, {
        label: $translate.instant('dashBoard.fleetManagement.vehicleList.moreFunction.showPortalCommand'),
        execute: showPortalCommand
      }*/]
    };

    $scope.ctxMenuSettings = vehicleListWidgetService.getContextMenuSettings(165);
    $scope.ctxMenuSettings = _.extend($scope.ctxMenuSettings, {
      source: _contextSourceObj.lastLocCtxSource, popupZIndex: 999999
    });
    commonTrackService.getGtsUserSettings(false).then(function (userSettings) {
      gtsUserSettings = userSettings;
      return commonTrackService.getGtsAccountSettings(true);
    }).then(function () {
      return loadVehicleGroup();
    }).then(function () {
      return loadFleetServerDetails();
    }).finally(function () {
      $scope.dataLoadingFinished = true;
      if ($scope.vehicleGroup) {
        loadVechileList($scope.vehicleGroup, true);
      }
    });


    $scope.vehicleGroupComboChange = function (event) {
      var vehicleGroup = event.args.item;
      // var statusCode = $('#statusCodeComboBox').jqxComboBox('getSelectedItem');
      if (config.vehicleGroup !== vehicleGroup.value) {
        if ($scope.vehicleLastLocGridSettings) {
          loadVechileList(vehicleGroup.value, $scope.vehicleLastLocGridSettings.columns.length > 0 ? false : true);
        }
      }
      if (vehicleGroup) {
        broadcastEventData.selectedVehicleGroup = vehicleGroup.value;
        broadcastEventData.selectedVehicleGroupLabel = vehicleGroup.label;
        config.vehicleGroup = vehicleGroup.value;
        var loginid = AuthenticationService.GetLoginID();
        localStorageService.set('selected_vehicleGroup.' + loginid.Account + '.' + loginid.username, config.vehicleGroup);
        commonTrackService.setLastLocatioWidgetData(broadcastEventData);
        broadcastEventData.dashboardName = 'dashboard.vehicleList';
        broadcastEventData.isDataFromTab = true;
        broadcastEventData.tabNumber = $scope.activeTab;
        $rootScope.$broadcast('vehicleGroupChanged', broadcastEventData);
      }
    };


    function copyLocation() {
      var selectIndex = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getselectedrowindex');
      if (selectIndex > -1) {
        var rowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('getrowdata', selectIndex);
        //console.log(rowData);
        if (rowData.geopoint) {
          var location = {
            lat: rowData.geopoint.split('/')[0],
            lon: rowData.geopoint.split('/')[1]
          };
          commonTrackService.copyToClipboard(JSON.stringify(location));
        }
      }
    }

    // update vehicle map widget  based on selected vechile id
    $scope.vehicleLastLocRowSelectHandler = function (event) {
      if (event.type === 'rowselect' && event.args.row) {
        _lastSelctedDeviceId = event.args.row.deviceid || null;
        $rootScope.$broadcast('init-widget-data-from-server', { deviceID: _lastSelctedDeviceId, selectedRow: event.args.row });

        broadcastEventData.selectedRow = event.args.row;
        //https://bugzilla.app.dsa.de/bugzilla/show_bug.cgi?id=105358#c6 , updateMapUrl flag should be based set based on '$scope.activeTab',
        // broadcastEventData.lastTabName can be inconsistent
        broadcastEventData.updateMapUrl = $scope.activeTab === TAB_VEHICLE_DETAILS || $scope.activeTab === TAB_CARGO_QUALITY ? false : true;
        broadcastEventData.updateWidgetTitle = true;
        broadcastEventData.selectedOrderRow = null;
        broadcastEventData.gridName = 'vehicleLastLocation';
        broadcastEventData.isTermoWidgetDependent = true;
        // tab check necessary to prevent async row select which result in wrong map URL in Vehicle Map widget.
        if ($scope.activeTab === TAB_VEHICLE_LIST) {
          broadcastEventData.dashboardName = 'dashboard.vehicleList';
          broadcastEventData.isDataFromTab = true;
          broadcastEventData.tabNumber = TAB_VEHICLE_LIST;
          $rootScope.$broadcast('rowSelected', broadcastEventData);
        }

        // stateManagerService
        // on row select push data to service, and broadcast dataStateUpdate
        var date = commonTrackService.formatReportDateTime(event.args.row.date, event.args.row.time);

        $scope.dataSet.deviceID = _lastSelctedDeviceId;
        $scope.dataSet.startDate = date;
        $scope.dataSet.endDate = date;

        stateManagerService.updateDeviceID('vehicleListWidget', _lastSelctedDeviceId, true);
        stateManagerService.updateStartDate('vehicleListWidget', date, true);
        stateManagerService.updateValue('vehicleListWidget', 'endDate', date, true);
        stateManagerService.updateValue('vehicleListWidget', 'rowData', event.args.row, false);
        stateManagerService.updateValue('vehicleListWidget', 'vehicleListRowData', event.args.row, false);
        stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', event.args.row, true);


        $rootScope.$broadcast('dataStateUpdate',
          {
            widget: 'vehicleListWidget',
            activeTab: $scope.activeTab,
            dashboardName: 'dashboard.vehicleList',
            rowSelectOriginalEvent : event.args.originarlEvent || null // pass the original event to determine if the select from user or programatic
          });

        commonTrackService.setLastLocatioWidgetData(broadcastEventData);
        var pushPinIndex = event.args.row.index - 1;
        $rootScope.$broadcast('fleet-map-update', { pushPinIndex: pushPinIndex, deviceId: event.args.row.deviceid });
        $scope.vehicleDetailTab.disable = false;
        $scope.vehicleOrdersTab.disable = false;
        $scope.cargoQualityTab.disable = false;
        // refresh other dependent grid
        if ($scope.activeTab === TAB_ORDERS ) {
          var _tmpTimeFormat = _initRequestData('vehicleOrders', undefined, true);
          if (_tmpTimeFormat) {
            loadVehicleOrdersList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleOrders.columns.length > 0 ? false : true, _tmpTimeFormat._tmpStartDate, _tmpTimeFormat._tmpEndDate);

          }
          broadcastEventData.lastTabName = 'orders';
        } else if ($scope.activeTab === TAB_VEHICLE_DETAILS) {
          var _tmpVehicleDetailsTimefrmt = _initRequestData('vehicleDetail', undefined, true);
          if (_tmpVehicleDetailsTimefrmt) {
            loadVehicleEventDetailList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleEventDetails.columns.length > 0 ? false : true, _tmpVehicleDetailsTimefrmt._tmpStartDate, _tmpVehicleDetailsTimefrmt._tmpEndDate);
          }
          broadcastEventData.lastTabName = 'vehicleDetails';
        } else {
          broadcastEventData.lastTabName = 'lastLocation';
        }
        //save
        var loginid = AuthenticationService.GetLoginID();
        localStorageService.set('selected_vehicle.' + loginid.Account + '.' + loginid.username, {
          'deviceid': broadcastEventData.selectedRow.deviceid,
          'driverid': broadcastEventData.selectedRow.driverid
        });
      }
    };
    $scope.gridRowClickHandler = function (event) {
      if (event.args.rightclick) {
        if (!isLastLocationCtxInitialized) {
          lastLocationContextMenu = $('#'+$scope.uuidForElement+'_betoTrack_vehicleLastLocationCtx').jqxMenu($scope.ctxMenuSettings);
          $('#'+$scope.uuidForElement+'_betoTrack_vehicleLastLocationCtx').on('itemclick', lastLocationContextHandler);
          isLastLocationCtxInitialized = true;
        }
        commonTrackService.initGridRightClickContextMenu(event, lastLocationContextMenu);
      }
    };

    function lastLocationContextHandler(event) {

      commonTrackService.executeContextMenuClick(event, 'lastLocCtxSource', _contextSourceObj);
    }

    $scope.vehicleOrdersRowSelectHandler = function (event) {
      if (event.args.rightclick) {

        if (!isOrdersCtxInitialized) {
          ordersContextMenu = $('#'+$scope.uuidForElement+'_betoTrack_vehicleOrdersCtx').jqxMenu($scope.ctxMenuSettings);
          $('#'+$scope.uuidForElement+'_betoTrack_vehicleOrdersCtx').on('itemclick', lastLocationContextHandler);
          isOrdersCtxInitialized = true;
        }
        commonTrackService.initGridRightClickContextMenu(event, ordersContextMenu);

      }
      if (event.type === 'rowselect') {
        broadcastEventData.selectedOrderRow = event.args.row;
        if (event.args.row) {
          // tab check necessary to prevent async row select which result in wrong map URL in Vehicle Map widget.
          if ($scope.activeTab === TAB_ORDERS) {
            stateManagerService.updateValue('vehicleListWidget', 'orderRowData', event.args.row, false);
            stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', event.args.row, true);

            $rootScope.$broadcast('ordersRowSelected', {
              'repoVehicle': event.args.row.deviceid,
              'startDate': commonTrackService.formatReportDateTime(event.args.row.workorderstartdate, event.args.row.workorderstarttime, false),
              'endDate': commonTrackService.formatReportDateTime(event.args.row.workorderenddate, event.args.row.workorderendtime, false),
              updateWidgetTitle: false,
              dashboardName: 'dashboard.vehicleList',
              isDataFromTab: true,
              tabNumber: 1,
              orderid: event.args.row.orderid
            });
            stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', event.args.row, true);

            $rootScope.$broadcast('dataStateUpdate',
            {
              widget: 'vehicleListWidget',
              timespan: new Date().getTime(),
              dashboardName: 'dashboard.vehicleList',
              activeTab: $scope.activeTab,
            });
          }
        }
      }
    };

    $scope.rowSelectHandler = function (event) {
      var _vehicleDetailRow = {};
      var isEventValidforSelectedTab = false;
      _vehicleDetailRow.selectedRow = event.args.row;
      _vehicleDetailRow.selectedRow.deviceid = broadcastEventData.selectedRow.deviceid;
      if (event.currentTarget.id.indexOf('cargoQualityDetail') > 0) {
        _vehicleDetailRow.gridName = 'cargoQuality';
        isEventValidforSelectedTab = $scope.activeTab ===  TAB_CARGO_QUALITY  ? true : false;
        _vehicleDetailRow.updateMapUrl = false;
        stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', _vehicleDetailRow.selectedRow, false);
      }
      if (event.currentTarget.id.indexOf('vehicleEventDetail') > 0) {
        _vehicleDetailRow.gridName = 'vehicleDetail';
        _vehicleDetailRow.updateMapUrl = false;
        isEventValidforSelectedTab = $scope.activeTab ===  TAB_VEHICLE_DETAILS  ? true : false;
        stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', _vehicleDetailRow.selectedRow, false);
      }
      _vehicleDetailRow.updateWidgetTitle = false;
      _vehicleDetailRow.tabIndex = $scope.activeTab;

      // tab check necessary to prevent async row select which result in wrong map URL in Vehicle Map widget.
      if (isEventValidforSelectedTab) {
        _vehicleDetailRow.dashboardName = 'dashboard.vehicleList';
        _vehicleDetailRow.isDataFromTab = true;
        _vehicleDetailRow.tabNumber = $scope.activeTab;
        $rootScope.$broadcast('rowSelected', _vehicleDetailRow);
        if (event.type === 'rowselect') {
          commonTrackService.iframePostMessage('jsmShowDetailPushpinForRoute_Dsa(' + event.args.row.timestamp + ')', 'vehicleMap');
        }
      }


      // stateManagerService
      var date = commonTrackService.formatReportDateTime(event.args.row.date, event.args.row.time);

      $scope.dataSet.deviceID = _vehicleDetailRow.selectedRow.deviceid;
      $scope.dataSet.startDate = date;
      $scope.dataSet.endDate = date;

      stateManagerService.updateDeviceID('vehicleListWidget', _vehicleDetailRow.selectedRow.deviceid, true);
      stateManagerService.updateStartDate('vehicleListWidget', date, true);
      stateManagerService.updateValue('vehicleListWidget', 'endDate', date, true);
      stateManagerService.updateValue('vehicleListWidget', 'rowData', _vehicleDetailRow.selectedRow, false);
      stateManagerService.updateValue('vehicleListWidget', 'tab_' + $scope.activeTab + '_selectedRow', _vehicleDetailRow.selectedRow, true);


      $rootScope.$broadcast('dataStateUpdate',
        {
          widget: 'vehicleListWidget',
          timespan: new Date().getTime(),
          dashboardName: _vehicleDetailRow.dashboardName,
          isDataFromTab: _vehicleDetailRow.isDataFromTab,
          activeTab: $scope.activeTab,
        });

    };

    $scope.startCounter = function () {
      $scope.stop();
      $scope.isTimerStated = true;
      $scope.timerDesc = $translate.instant('dashBoard.fleetManagement.vehicleList.stopAutoUpdate');
      if ($scope.counter - 1 >= 1) {
        $scope.counter--;
        counterTimeout = $interval($scope.startCounter, 1000);
      } else {
        var _vehicleGroup = window.$('#vehicleGroupComboBox').jqxComboBox('getSelectedItem');

        if (_vehicleGroup && _vehicleGroup.value) {
          loadVechileList(_vehicleGroup.value, false, true);
        }
        else {
          errorObj.message = $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleGroupValidation');
          toastService.showErrorToast(errorObj);
          $scope.stop();
        }
      }
    };


    $scope.stop = function () {
      $interval.cancel(counterTimeout);
    };

    function _updateSelectedRowData() {
      var selectedRowIndex = $('#_betoTrack_vehicleLastLocationList').jqxGrid('getselectedrowindex');
      if (selectedRowIndex >= 0) {
        var rowData = $('#_betoTrack_vehicleLastLocationList').jqxGrid('getrowdata', selectedRowIndex);
        broadcastEventData.selectedRow = rowData;
      }
    }

    function _initRequestData(dateRangeScopeName, formatType, isRefresh) {
      var _typeOfGridRow = $scope.activeTab === TAB_ORDERS && broadcastEventData.selectedOrderRow && !isRefresh ? 'selectedOrderRow' : 'selectedRow';
      return _getRequestTimeRange(dateRangeScopeName, _typeOfGridRow, formatType);
    }

    /**
     * Prepares the Request From and To time based on the provided grid ddetails .
     * if _typeOfGridRow is 'selectedOrderRow' : the Selected Row from the orders used to determine the From/To request time stamp
     * if _typeOfGridRow is 'selectedRow' : the Selected Row from the Main grid to determine the From/To request time stamp
     *
     * @param {*} dateRangeScopeName scope object name to store the request details
     * @param {*} _typeOfGridRow 'selectedOrderRow' from Orders TAB OR  'selectedRow' from the main Grid
     * @param {*} formatType  custom data format to override default
     * @returns request From/To time for the current tab.
     */
    function _getRequestTimeRange(dateRangeScopeName,_typeOfGridRow, formatType){
      if (_typeOfGridRow === 'selectedRow') {
        _updateSelectedRowData();
      }
      if (broadcastEventData[_typeOfGridRow].deviceid) {
        _tmpConfig.deviceId = broadcastEventData[_typeOfGridRow].deviceid;
        var _serverTimeFormat = {};
        _serverTimeFormat._tmpEndDate = _typeOfGridRow === 'selectedOrderRow' ? commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].workorderenddate, broadcastEventData[_typeOfGridRow].workorderendtime, formatType) : commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].date, broadcastEventData[_typeOfGridRow].time, formatType);
        _serverTimeFormat._tmpStartDate = _typeOfGridRow === 'selectedOrderRow' ? commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].workorderstartdate, broadcastEventData[_typeOfGridRow].workorderstarttime, formatType) : commonTrackService.formatReportDateTime(broadcastEventData[_typeOfGridRow].date, '00:00:00', formatType);

        $scope[dateRangeScopeName] = {
          date: {
            startDate: new Date(_serverTimeFormat._tmpStartDate.replaceAt(10, ' ')),
            endDate: new Date(_serverTimeFormat._tmpEndDate.replaceAt(10, ' '))
          }
        };

        return _serverTimeFormat;
      }
      else {
        return null;
      }
    }

    /**
     * The Request Time range changes based on the 'TAB' the user previously clicked.
     *
     * Time range of selected ORDER if : User previously visited the Orders TAB
     *
     * Time range of selected VEHICLE from the main dashboard should be used if : User previously visited not 'Orders' Tab
     *
     * Prepares the Request data and assgin it to scope object 'scope.vehicleDetail'
     *
     */
    function _intiVehicleDetailRequestData(){
      //used the selected row details from the orders grid : IF  Previous tab is 'Orders'
      //  use selected row details from main dashboard grid:IF  Previous tab is NOT 'Orders'
      var _typeOfGridRow = $scope.previousTab === TAB_ORDERS && broadcastEventData.selectedOrderRow ? 'selectedOrderRow' : 'selectedRow';
      return _getRequestTimeRange('vehicleDetail', _typeOfGridRow);
    }


    // vehicle details tab functions
    var loadVehicleEventDetailList = function (deviceId, dataRefresh, startDate, endDate) {
      return vehicleListWidgetService.getVehicleEventDetailList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleEventDetailResult) {
        $scope.isDetialAvailable = true;
        if (vehicleEventDetailResult.dataList) {
          if (dataRefresh) {
            $scope.customGridProperties.vehicleEventDetails.columns = commonTrackService.getColumnProperties(vehicleEventDetailResult.gridSettings.overviewListGrids[0].columnProperties, vehicleEventDetailResult.columnTranslation, { moduleName: 'vehicleEventDetails' });
            var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.vehicleDetailsTab.vehicleDetails') };
            $scope.vehicleDetailsGridSettings = commonTrackService.getGridSettings('vehicleEventDetails', $scope.customGridProperties.vehicleEventDetails, null, _additionalProperties);
            $scope.vehicleDetailsGridSettings.source = vehicleEventDetailResult.dataList;
          } else {
            $scope.vehicleDetailsGridSettings.source = vehicleEventDetailResult.dataList;
          }
          if ($scope.activeTab ===  TAB_VEHICLE_DETAILS ) { // race condition this may come latter when tab is actually changed
             if(vehicleEventDetailResult.dataList.length === 0 ){ // reset exising map details
              deviceId =  null;
              startDate =  null ;
              endDate = null ;
             }
            $rootScope.$broadcast('tabEvent', {
              'tabName': 'vechileEventDetail',
              'repoVehicle': deviceId,
              'startDate': startDate,
              'endDate': endDate,
              dashboardName: 'dashboard.vehicleList',
              isDataFromTab: true,
              tabNumber:  TAB_VEHICLE_DETAILS
            });
          }

          // expecting map to be ready after 4 seconds and send row select which will update map for pushpin

          $timeout(function () {
            var rowindex = _getCurrentRowIndex('vehicleEventDetailsList', vehicleEventDetailResult.dataList.length);
            if (rowindex) {
              window.$('#' + $scope.overviewGridPrefix + 'vehicleEventDetailsList').jqxGrid('selectrow', rowindex);
            }
          }, 3000);

        }
      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isDetialAvailable = false;
        }
      }).finally(function () {
        $scope.createVehicleDetilListGrid = true;
        broadcastEventData.lastTabName = 'vehicleDetails';
      });
    };

    // vehicle orders
    function clearVehicleOrdersList() {
      try {
        $('#_betoTrack_vehicleOrdersList').jqxGrid('clear');
      } catch (err) {
        //continue with code
      }
    }

    function updateVehicleOrdersList() {
      try {
        $('#_betoTrack_vehicleOrdersList').jqxGrid('updatebounddata');
      } catch (err) {
        //continue with code
      }
    }

    var loadVehicleOrdersList = function (deviceId, dataRefresh, startDate, endDate) {
      clearVehicleOrdersList();

      return vehicleListWidgetService.getVehicleOrdersList(deviceId, dataRefresh, startDate, endDate).then(function (vehicleOrdersResult) {
        $scope.isOrderAvailable = true;
        if (vehicleOrdersResult.dataList) {
          if (dataRefresh) {

            $scope.customGridProperties.vehicleOrders.columns = commonTrackService.getColumnProperties(vehicleOrdersResult.gridSettings.overviewListGrids[0].columnProperties, vehicleOrdersResult.columnTranslation, { moduleName: 'vehicleOrders' });
            var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.ordersTab.orders') };
            $scope.vehicleOrdersSettings = commonTrackService.getGridSettings('vehicleOrders', $scope.customGridProperties.vehicleOrders, null, _additionalProperties);
            $scope.vehicleOrdersSettings.source = vehicleOrdersResult.dataList;
          } else {
            $scope.vehicleOrdersSettings.source = vehicleOrdersResult.dataList;
          }
        }
        return vehicleOrdersResult.dataList;
      }, function (response) {
        if (errorHandlingService.errorForNoAuthorized(response)) {
          $scope.isOrderAvailable = false;
        }
      }).finally(function () {
        $scope.createVehicleOrdersListGrid = true;
        updateVehicleOrdersList();
      });
    };
    $scope._initLastLocationTab = function () {
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings));
      //$scope.ctxMenuSettings.source = _contextSourceObj.lastLocCtxSource;

      $rootScope.$broadcast('tabEvent', {
        'tabName': 'lastLocation',
        dashboardName: 'dashboard.vehicleList',
        isDataFromTab: true,
        tabNumber: 0,
        deviceId: _lastSelctedDeviceId
      });

      broadcastEventData.lastTabName = 'lastLocation';
      $scope.previousTab = $scope.activeTab;

      if (!$scope.isStopedByUser) {
        $scope.stop();
        $scope.stopAutoRefresh(null, 'start');
      }
    };

    $scope._initOrderTab = function () {
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings));

      // $scope.ctxMenuSettings.source = _contextSourceObj.ordersCtxSource;
      $scope.stopAutoRefresh(null, 'stop');
      var timeFormat = {};
      var lastTabBasedTime = {};
      //---------------------------------------------------------------------------------------------------------------------------------------
      // Following code should be improved in a seprate bug , with a more detialed test case
      // The use case is the following
      // 1. when you clcik orders tab form the main TAB (0) , use the selected row information from the TAB(0)
      // 2. when you ckick orders tab from the vehicleDetails TAB(2) , use the selected row information from the TAB(2)
      //----------------------------------------------------------------------------------------------------------------------------------------
       // 2. when you ckick orders tab from the vehicleDetails TAB(2) , use the selected row information from the TAB(2)
      if (broadcastEventData.lastTabName === 'vehicleDetails') {
        if (broadcastEventData.selectedOrderRow) {
          timeFormat._tmpStartDate = $filter('date')($scope.vehicleOrders.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
          timeFormat._tmpEndDate = $filter('date')($scope.vehicleOrders.date.endDate, 'yyyy/MM/dd/HH:mm:ss');
        } else {

          timeFormat._tmpStartDate = $filter('date')($scope.vehicleDetail.date.startDate, 'yyyy/MM/dd/HH:mm:ss');
          timeFormat._tmpEndDate = $filter('date')($scope.vehicleDetail.date.endDate, 'yyyy/MM/dd/HH:mm:ss');

          $scope.vehicleOrders = {
            date: {
              startDate: timeFormat._tmpStartDate._isAMomentObject ?timeFormat._tmpStartDate.format('YYYY/MM/DD HH:mm:ss') : new Date(timeFormat._tmpStartDate.replaceAt(10, ' ')),
              endDate: timeFormat._tmpEndDate._isAMomentObject ? timeFormat._tmpEndDate.format('YYYY/MM/DD HH:mm:ss'):new Date(timeFormat._tmpEndDate.replaceAt(10, ' '))
            }
          };
        }

      } else {
         // 1. when you clcik orders tab form the main TAB (0) , use the selected row information from the TAB(0)
        timeFormat = _initRequestData('vehicleOrders');
        window.$('#' + $scope.overviewGridPrefix + 'vehicleOrdersList').jqxGrid('clearselection');
      }

      //---------------------------------------------------------------------------------------------------------------------------------------

      broadcastEventData.lastTabName = 'orders';
      if (timeFormat) {
        loadVehicleOrdersList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleOrders.columns.length > 0 ? false : true, timeFormat._tmpStartDate, timeFormat._tmpEndDate).then(function (orderList) {
          $timeout(function () {
            if (orderList && orderList.length > 0) {
              //default select the first one
              var rowIndex = _getCurrentRowIndex('vehicleOrdersList', orderList.length);
              if (rowIndex) {
                var rowData = window.$('#' + $scope.overviewGridPrefix + 'vehicleOrdersList').jqxGrid('getrowdata', rowIndex);
                if (rowData) {
                  lastTabBasedTime._tmpStartDate = commonTrackService.formatReportDateTime(rowData.workorderstartdate, rowData.workorderstarttime, false);
                  lastTabBasedTime._tmpEndDate = commonTrackService.formatReportDateTime(rowData.workorderenddate, rowData.workorderendtime, false);
                  broadcastEventData.selectedOrderRow = rowData;
                  if ($scope.activeTab ===   TAB_ORDERS ) {
                    $rootScope.$broadcast('tabEvent', {
                      'tabName': 'vehicleOrders',
                      'repoVehicle': rowData.deviceid,
                      'startDate': lastTabBasedTime._tmpStartDate ? lastTabBasedTime._tmpStartDate : timeFormat._tmpStartDate,
                      'endDate': lastTabBasedTime._tmpEndDate ? lastTabBasedTime._tmpEndDate : timeFormat._tmpEndDate,
                      dashboardName: 'dashboard.vehicleList',
                      isDataFromTab: true,
                      tabNumber: 0 // check why this 0 ,
                    });
                  }

                }
              }

            } else {
              //no record in the grid.
              if ($scope.activeTab === TAB_ORDERS) {
                $rootScope.$broadcast('tabEvent', {
                  'tabName': 'vehicleOrders',
                  'repoVehicle': null,
                  'startDate': null,
                  'endDate': null,
                  dashboardName: 'dashboard.vehicleList',
                  isDataFromTab: true,
                  tabNumber: TAB_ORDERS
                });
              }

            }
          }, 0);
        });
      }
      $scope.previousTab = $scope.activeTab;
    };

    function _getCurrentRowIndex(gridName, dataLenght) {
      var rowindex = window.$('#' + $scope.overviewGridPrefix + gridName).jqxGrid('getselectedrowindex');
      if (rowindex > dataLenght - 1 || rowindex <= 0) {
        rowindex = 0;
        window.$('#' + $scope.overviewGridPrefix + gridName).jqxGrid('selectrow', rowindex);
        return null;
      }
      return rowindex;
    }

    $scope._initVehicleDetailTab = function () {
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,'EventDetail'));

      $scope.stopAutoRefresh(null, 'stop');
      var timeFormat = _intiVehicleDetailRequestData('vehicleDetail');
      if (timeFormat) {
        if ($scope.previousTab === 0 || $scope.previousTab === 1 && !broadcastEventData.selectedOrderRow) { // if last tab =1 OR condition is for  order tab with empty list

          var tmpFromDate = moment(timeFormat._tmpEndDate, 'YYYY/MM/DD/HH:mm:ss');
          tmpFromDate.subtract({ hours: 2 });
          timeFormat._tmpStartDate = tmpFromDate.format('YYYY/MM/DD/HH:mm:ss');
          $scope.vehicleDetail.date.startDate = timeFormat._tmpStartDate;
        }
        loadVehicleEventDetailList(_tmpConfig.deviceId, $scope.customGridProperties.vehicleEventDetails.columns.length > 0 ? false : true, timeFormat._tmpStartDate, timeFormat._tmpEndDate);
      }
      $scope.previousTab = $scope.activeTab;
    };

    $scope._initCargoQualityTabTab = function () {
      commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,'EventDetailCargoQuality'));

      $scope.stopAutoRefresh(null, 'stop');
      var timeFormat = _initRequestData('cargoQualityDetail');
      if (timeFormat) {
        if ($scope.previousTab === 0 || $scope.previousTab === 1 && !broadcastEventData.selectedOrderRow) { // if last tab =1 OR condition is for  order tab with empty list
          var tmpFromDate = moment(timeFormat._tmpEndDate, 'YYYY/MM/DD/HH:mm:ss');
          tmpFromDate.subtract({ hours: 2 });
          timeFormat._tmpStartDate = tmpFromDate.format('YYYY/MM/DD/HH:mm:ss');
          $scope.cargoQualityDetail.date.startDate = timeFormat._tmpStartDate;
        }
        loadCragoQualityList(_tmpConfig.deviceId, $scope.customGridProperties.cargoQualityDetail.columns.length > 0 ? false : true, timeFormat._tmpStartDate, timeFormat._tmpEndDate);
      }
      $scope.previousTab = $scope.activeTab;
    };

    var loadCragoQualityList = function (deviceId, dataRefresh, startDate, endDate) {
      return vehicleListWidgetService.getCargoQualityList(deviceId, dataRefresh, startDate, endDate).then(function (cargoQualityList) {
        if (cargoQualityList.dataList) {
          if (dataRefresh) {
            $scope.customGridProperties.cargoQualityDetail.columns = commonTrackService.getColumnProperties(cargoQualityList.gridSettings.overviewListGrids[0].columnProperties, cargoQualityList.columnTranslation, { moduleName: 'cargoQualityDetail' });
            var _additionalProperties = { translatedName: $translate.instant('dashBoard.fleetManagement.vehicleList.cargoQualityTab.cargoQuality') };
            $scope.cargoQualityGridSettings = commonTrackService.getGridSettings('cargoQualityDetail', $scope.customGridProperties.cargoQualityDetail, null, _additionalProperties);
            $scope.cargoQualityGridSettings.source = cargoQualityList.dataList;
          } else {
            $scope.cargoQualityGridSettings.source = cargoQualityList.dataList;
          }
          $timeout(function () {
            var rowindex = _getCurrentRowIndex('cargoQualityDetailList', cargoQualityList.dataList.length);
            if (rowindex) {
              window.$('#' + $scope.overviewGridPrefix + 'cargoQualityDetailList').jqxGrid('selectrow', rowindex);
            }
          }, 3000);
          if ($scope.activeTab ===  TAB_CARGO_QUALITY ) {
            $rootScope.$broadcast('tabEvent', {
              'tabName': 'cargoQuality',
              'repoVehicle': deviceId,
              'startDate': startDate,
              'endDate': endDate,
              dashboardName: 'dashboard.vehicleList',
              isDataFromTab: true,
              tabNumber: TAB_CARGO_QUALITY
            });
          }

        }
      }).finally(function () {

        $scope.createCargoQualityGrid = true;
      });
    };

    var jobEvent = $scope.$on('job-event', function (event, data) {
      var _eventDateTime = new Date(data.eventTimeStamp * 1000);
      var _gridRefreshDateTime = new Date(_lastRefreshTimeS * 1000);
      // console.log('data.eventTimeStamp - ' + _eventDateTime);
      // console.log('grid refresh time - ' + _gridRefreshDateTime);
      // console.log(_eventDateTime > _gridRefreshDateTime);

      if (_eventDateTime > _gridRefreshDateTime) {
        var _tmpGridsource = vehicleListSource.localdata;
        for (var i = 0; i < _tmpGridsource.length; i++) {
          if (_tmpGridsource[i].deviceid === data.dev) {
            _tmpGridsource[i].statusdesc = data.statusdescription;
            _tmpGridsource[i].statusdescColor = data.statusdescFgColor;
            _tmpGridsource[i].statusdescBgColor = data.statusdescBgColor;
            _tmpGridsource[i].lastjobstatusdesc = data.statusdescription;
            _tmpGridsource[i].lastjobstatusdescColor = data.statusdescFgColor;
            _tmpGridsource[i].lastjobstatusdescBgColor = data.statusdescBgColor;
            _tmpGridsource[i].driverdesc = data.driverdesc !== null ? data.driverdesc : '';
            _tmpGridsource[i].date = $filter('date')(_eventDateTime, 'dd/MM/yyyy');
            _tmpGridsource[i].time = $filter('date')(_eventDateTime, 'HH:mm:ss');
            $scope.vehicleLastLocGridSettings.source = _tmpGridsource;
            window.$('#' + $scope.overviewGridPrefix + 'vehicleLastLocationList').jqxGrid('updatebounddata', 'data');
            break;
          }
        }
      }
    });

    var updateDateRangeInternalDateEvent = $scope.$on('date-range-internalDate-old', function () {
      var tab = $scope.activeTab === TAB_CARGO_QUALITY  ? 'EventDetailCargoQuality' : $scope.activeTab === TAB_VEHICLE_DETAILS ? 'EventDetail' : undefined;
      $scope.options.ranges = commonTrackService.setDateRangePickerCustomOptions($scope.options, commonTrackService.getDateRangePickerRange(dateRangePickerSettings,tab));
    });

    $scope.moreFunctionsOnChange = function (event) {
      if (event.args.item.value === 'showReport') {
        var _objNameParam = event.args.item.originalItem.execute.split('-');
        _commonFunction[_objNameParam[0]](_objNameParam[1]);
      } else {
        if (event.args.item.originalItem.execute) {
          _commonFunction[event.args.item.originalItem.execute]();
        }
      }
      window.$('#moreFunDropDown').jqxDropDownList('clearSelection');

    };

    $scope.stopAutoRefresh = function (event, type) {
      if (event) {
        commonTrackService.getRefreshStartStopfunction($scope, true, true, loadVechileList, 'vehicleGroupComboBox', false, true, event)();
      } else {
        if (type === 'start') {
          $scope.isTimerStated = false;
        } else {
          $scope.isTimerStated = true;
        }
        commonTrackService.getRefreshStartStopfunction($scope, true, true, loadVechileList, 'vehicleGroupComboBox', false, true)();
      }
    };

    var currentSelectedRowReqEvent = $scope.$on('vehicleMap_req_current_context', function () {
      $rootScope.$broadcast('vehicleMap_res_current_context', {
        dashboardName: 'dashboard.vehicleList',
        isDataFromTab: true,
        tabNumber: $scope.activeTab,
        currentWidgetContextData: broadcastEventData,
        dataLoadingFinished: $scope.dataLoadingFinished,
        isDataAvailable: $scope.isDataAvailable
      });
    });

    var currentSelectedGroupEvent = $scope.$on('fleetMap_req_current_context', function () {
      $rootScope.$broadcast('fleetMap_res_current_context', {
        dashboardName: 'dashboard.vehicleList',
        vehicleGroup: $scope.vehicleGroup
      });
    });

    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    // Google maps takes focus if the auto refresh enabled
    // Auto refresh must be stoped if the chat window is open to solve focus switching
    var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
      // stop the auto refresh only if an existing timer is detected under the last location tab
      // bug 105133
      if ($scope.isTimerStated && $scope.activeTab === TAB_VEHICLE_LIST ) {  // start auto refresh only if the last location tab is open , if not the tab change does the start of auto refresh
        $scope.stopAutoRefresh(null, 'stop');
      }

    });
    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    //  restart the auto refresh is the chat window is closed
    var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
      if (!$scope.isTimerStated && $scope.activeTab === TAB_VEHICLE_LIST ) { // start auto refresh only if the last location tab is open , if not the tab change does the start of auto refresh
        $scope.stopAutoRefresh(null, 'start');
      }

    });

    $scope.$on('$destroy', function () {
      $scope.stop();
      jobEvent();
      updateDateRangeInternalDateEvent();
      currentSelectedRowReqEvent();
      destroyLastLocationCtxMenu();
      destroyVehicleOrdersCtxMenu();
      updateRequest();
      if(chatWindowOpenEvent){
        chatWindowOpenEvent();
      }
      if(chatWindowCloseEvent){
        chatWindowCloseEvent();
      }
      if ($scope.vehicleLastLocGridSettings && $scope.vehicleLastLocGridSettings.source) {
        delete $scope.vehicleLastLocGridSettings.source;
      }
      if ($scope.vehicleOrdersSettings && $scope.vehicleOrdersSettings.source) {
        delete $scope.vehicleOrdersSettings.source;
      }
      if ($scope.vehicleDetailsGridSettings && $scope.vehicleDetailsGridSettings.source) {
        delete $scope.vehicleDetailsGridSettings.source;
      }
      if ($scope.cargoQualityGridSettings && $scope.cargoQualityGridSettings.source) {
        delete $scope.cargoQualityGridSettings.source;
      }
      delete $scope.vehicleListdataAdapter;
      currentSelectedGroupEvent();
    });

    $scope.$on('$locationChangeStart', function () {
      destroyLastLocationCtxMenu();
      destroyVehicleOrdersCtxMenu();
    });

    function destroyLastLocationCtxMenu() {
      $('#'+$scope.uuidForElement+'_betoTrack_vehicleLastLocationCtx').unbind('itemclick', lastLocationContextHandler);
      $('#'+$scope.uuidForElement+'_betoTrack_vehicleLastLocationCtx').jqxMenu('destroy');
    }

    function destroyVehicleOrdersCtxMenu() {
      $('#'+$scope.uuidForElement+'_betoTrack_vehicleOrdersCtx').unbind('itemclick', lastLocationContextHandler);
      $('#'+$scope.uuidForElement+'_betoTrack_vehicleOrdersCtx').jqxMenu('destroy');
    }

  }).controller('vehicleListEditCtrl', function ($scope, config, $translate, widgetSettingsCreatorService) {
    $scope.noOfGridRows = config.noOfGridRows;
    var source = [
      '5', '10', '15', '25', '50', '75', '100'
    ];

    // init DropDownList's settings object.
    $scope.noOfRowsettings =
    {
      placeHolder: $translate.instant('dashBoard.fleetManagement.vehicleList.noOfGridRows'),
      width: 200, height: 25,
      autoDropDownHeight: true,

      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
      source: source
    };

    $scope.noOfGridOnChange = function (event) {
      config.noOfGridRows = event.args.item.value;
    };
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/vehicle/vehicleListWidget.js